function pathMatchesPrefix(url: string, path: string): boolean {
  return url === path || url.startsWith(path + '/');
}

function portalSection(path: string): string | null {
  const parts = path.split('/').filter(Boolean);
  return parts[0] === 'portal' && parts[1] ? `/portal/${parts[1]}` : null;
}

export function routeMatchesUrl(url: string, route: ThemisRoute): boolean {
  const normalizedUrl = url.toLowerCase().split('?')[0];
  const routePath = route.route?.toLowerCase();
  if (!routePath) {
    return false;
  }
  if (pathMatchesPrefix(normalizedUrl, routePath)) {
    return true;
  }
  const section = portalSection(routePath);
  return section != null && pathMatchesPrefix(normalizedUrl, section);
}

export class ThemisRoute {
  /**
   * `_permission` is the slug the destination's own endpoints require. The navbar
   * drops any route whose slug the user does not hold, so navigation and the API
   * agree by construction. Routes without one are always shown.
   */
  constructor(private _name: string, private _admin: boolean, private _image?: string, private _route?: string, private _category?: string, private _hidden: boolean = false, private _permission?: string) {

  }

  public get permission(): string | undefined { return this._permission; }
  public get name() { return this._name }
  public get admin() { return this._admin }
  public get image(): string { return this._image ?? 'assets/navbar/icon.png'; }
  public get category(): string { return this._category ?? ''; }
  public get hidden(): boolean { return this._hidden; }
  public get route() {
    if (this._route) return this._route;
    if (this._admin && this._name == "Meetings")
      return `/portal/meetings`;
    if (this._name == "Team Excuses")
      return `/portal/team-excuses/all`;
    return `/portal/${this.name.toLowerCase().replace(/\s+/g, '-')}`
  }
}
